/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        appBar: {
            backgroundColor: {
                value: "#2F3B4D",
                type: "color",
            },
            paddingLeft: {
                value: "20px",
                type: "dimension",
            },
            paddingRight: {
                value: "16px",
                type: "dimension",
            },
            paddingVertical: {
                value: "12px",
                type: "dimension",
            },
            minHeight: {
                value: "64px",
                type: "dimension",
            },
            customer: {
                fontSize: {
                    value: "1.125rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.5rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
            },
            actions: {
                gap: {
                    value: "4px",
                    type: "dimension",
                },
            },
            titleBar: {
                paddingVertical: {
                    value: "16px",
                    type: "dimension",
                },
            },
            pageTitle: {
                fontSize: {
                    value: "2.5rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "3rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
            },
        },
    },
};
export default tokens;
